/*
props: {
  type: 个人或专家
  changeTitle: 改变页面title方法
}
 */
import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import store from '../../store';
import { observer } from 'mobx-react';
import axios from 'axios';
import xss from 'xss';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import List from '../../components/ArticleList'
import PersonVideoList from '../../components/PersonVideoList'
import Login from '../../components/Login';
import AudioPlayer from '../../components/AudioPlayer';
import OpenAppChannel from '../OpenAppChannel';
import { getUseParams, removeCookies } from '../../utils/baseUtil';
import { setWeixinData } from '../../utils/wxShareUtil';
import { dateDiff } from '../../utils/dateUtil';

dayjs.locale('zh-cn');

let page = '';
let list = [];
let errorTimer = null;
let loading = false;

// 用户类型(0未认证用户1普通用户2记者3专家4其他 5蓝鲸号)
const Person = (props) => {
  const location = useLocation();
  const query = getUseParams(location.search);
  let history = useHistory();
  const type = props.type;

  const [detail, setDetail] = useState({});
  const [description, setDescription] = useState(true);
  const [navActive, setNavActive] = useState(null);
  const [expertList, setExpertList] = useState([]);
  const [isShowLogin, setIsShowLogin] = useState(false);
  const [isShowApply, setIsShowApply] = useState(false);
  const [applyType, setApplyType] = useState('');
  const [errorText, setErrorText] = useState('');
  const [arrowShown, setArrowShown] = useState(false);
  const [navList, setNavList] = useState([]);
  const [hasMore, setHasMore] = useState(false);

  const token = store.token || '';
  const phone = store.user || '';
  const userInformation = store.userInformation || {};

  const audio = useRef({});
  const [currentAudioId, setCurrentAudioId] = useState(0);
  const audioProgress = useRef({});
  const contentRef = useRef({});
  const intersectionObserver = useRef(null);
  const loadingDivRef = useRef(null);

  const { changeTitle } = props;

  useEffect(() => {
    return () => {
      clearTimeout(errorTimer);
    }
  }, []);

  useEffect(() => {
    // 视频
    if (Array.isArray(navList) && navList.length > 0 && navList[navList.length - 1]['name'] === '视频') {
      return
    } else {
      axios.get(`/api2/user/video/${query.id}/1`, {
        timeout: 5000,
      }).then((response) => {
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 0 && Array.isArray(response.data.data) && !!response.data.data.length) {
            setNavList([...navList, { key: 6, name: '视频' }])
          }
        }
      }).catch((error) => { });
    }
  }, [navList]);

  useEffect(() => {
    if (detail.desc) {
      if (contentRef.current.offsetHeight > 44) {
        setDescription(false)
        setArrowShown(true)
      } else {
        setDescription(false)
      }
    }
  }, [detail.desc]);

  useEffect(
    () => {
      changeTitle((detail.real_name || '') + '个人页');
    },
    [changeTitle, detail.real_name]
  );

  useEffect(
    () => {
      if (!!token && !!phone && !!applyType) {
        if (typeof userInformation.code === 'number') {
          if (userInformation.code === 0 && !!userInformation.data && typeof userInformation.data.type === 'number') {
            if (userInformation.data.is_auth === 3) {
              drawErrorModal('认证中，请认证完成后修改～');
            } else if (userInformation.data.type !== 2 && userInformation.data.type !== 3 && userInformation.data.type !== 5) {
              history.push({
                pathname: 'qa_authentication.html',
                state: {
                  token,
                  phone,
                  type: applyType
                },
                search: location.search
              })
            } else {
              if (userInformation.data.type === 2 || userInformation.data.type === 3 || userInformation.data.type === 5) {
                drawErrorModal(userInformation.data.type === 3 ? '已为专家' : userInformation.data.type === 2 ? '已为记者' : '已为蓝鲸号');
              }
            }
          } else if (userInformation.code !== 0) {
            removeCookies();
            setIsShowLogin(true);
          }
        }
      } else if ((!token || !phone) && !!applyType) {
        setIsShowLogin(true);
      }
    },
    [token, phone, type, history, applyType, location.search, userInformation]
  );

  useEffect(() => {
    if (isShowApply) {
      document.documentElement.style.overflowY = 'hidden'
    } else {
      document.documentElement.style.overflowY = 'scroll'
    }

    return (() => {
      document.documentElement.style.overflowY = 'scroll'
    })
  }, [isShowApply])

  useEffect(() => {
    if (!!query.id) {
      axios.get('/api2/user/center', {
        timeout: 5000,
        params: {
          uid: query.id
        },
      }).then((response) => {
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 0 && response.data.data) {
            const data = response.data.data;
            if (typeof setWeixinData !== 'undefined') {
              setWeixinData(`${data.real_name}的个人主页，欢迎沟通交流`, data.desc, data.share_logo);
            }
            setDetail(data);
            setNavList([{ key: 4, name: '回答' }, { key: 5, name: '观点' }])
            let nav = 4;
            if (type === 'reporter') {
              getQuestionList();
              setNavList([{ key: 1, name: '提问' }, { key: 2, name: '文章' }])
              nav = 1;
            } else if (type === 'proficient') {
              getAnswer();
            } else if (type === 'lanjing') {
              setNavList([{ key: 7, name: '作品' }]);
              nav = 7;
              getArticle();
            }
            setNavActive(nav);
          }
        }
      }).catch((error) => {
      });
    }
  }, [query.id]);

  useEffect(() => {
    if (hasMore && navActive !== 6) {
      clearObserver();
      initObserver();
    } else {
      clearObserver();
    }

    return (() => {
      clearObserver();
    })
  }, [hasMore])

  const initObserver = () => {
    intersectionObserver.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        switch (navActive) {
          case 1:
            getQuestionList(page);
            break;
          case 2:
            getArticle(page);
            break;
          case 3:
            getLeague(page);
            break;
          case 4:
            getAnswer(page, 0);
            break;
          case 5:
            getAnswer(page, 1);
            break;
          case 7:
            getArticle(page);
            break;
          default:
        }
      }
    }, {
      root: null,
      rootMargin: '0px 0px 100px 0px',
      threshold: 0
    });
    if (loadingDivRef.current) {
      intersectionObserver.current.observe(loadingDivRef.current);
    }
  }

  const clearObserver = () => {
    if (intersectionObserver.current && loadingDivRef.current) {
      intersectionObserver.current.unobserve(loadingDivRef.current);
      intersectionObserver.current.disconnect();
      intersectionObserver.current = null;
    }
  }

  const getQuestionList = (page_no) => {
    if (!!query.id) {
      if (loading) return;
      loading = true;
      axios.get('/api2/user/reporter/questions', {
        timeout: 5000,
        params: {
          uid: query.id,
          lastTime: page_no || 0,
          pageSize: 10,
          isOther: true
        },
      }).then((response) => {
        loading = false;
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 0 && Array.isArray(response.data.data)) {
            const dataList = response.data.data;
            if (dataList.length > 0) {
              if (dataList.length < 10) {
                setHasMore(false);
              } else {
                if (!page_no) {
                  setHasMore(true);
                }
              }
              list = !page_no ? dataList : list.concat(dataList);
              setExpertList(list);
              page = dataList[dataList.length - 1].create_time || '';
            } else {
              setHasMore(false);
              if (!page_no) {
                list = '没有相关内容';
                setExpertList(list);
              }
              page = Array.isArray(list) && list.length ? (list[list.length - 1].create_time || '') : '';
            }
          }
        }
      }).catch((error) => {
        loading = false;
        // const expertListLength = expertList.length;
        // page = !!expertListLength ? (expertList[expertListLength - 1].create_time || '') : '';
      });
    }
  };

  const getAnswer = (page_no, type) => {
    if (!!query.id) {
      if (loading) return;
      loading = true;
      axios.get('/api2/user/proficient/viewpoints', {
        timeout: 5000,
        params: {
          uid: query.id,
          viewpointType: !type ? 0 : 1,
          lastTime: page_no || 0,
          pageSize: 10,
          isOther: true
        },
      }).then((response) => {
        loading = false;
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 0 && Array.isArray(response.data.data)) {
            const dataList = response.data.data;
            if (dataList.length > 0) {
              if (dataList.length < 10) {
                setHasMore(false);
              } else {
                if (!page_no) {
                  setHasMore(true);
                }
              }
              list = !page_no ? dataList : list.concat(dataList);
              setExpertList(list);
              page = dataList[dataList.length - 1].create_time || '';
            } else {
              setHasMore(false);
              if (!page_no) {
                list = '没有相关内容';
                setExpertList(list);
              }
              page = Array.isArray(list) && list.length ? (list[list.length - 1].create_time || '') : '';
            }
          }
        }
      }).catch((error) => {
        loading = false;
      });
    }
  };

  const getArticle = (page_no) => {
    if (!!query.id) {
      if (loading) return;
      loading = true;
      axios.get('/api/v1/user/reporter/articles', {
        timeout: 5000,
        params: {
          uid: query.id,
          last_time: page_no || '',
          page_size: 10
        }
      }).then((response) => {
        loading = false;
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 200 && Array.isArray(response.data.data)) {
            const dataList = response.data.data;
            if (dataList.length > 0) {
              if (dataList.length < 10) {
                setHasMore(false);
              } else {
                if (!page_no) {
                  setHasMore(true);
                }
              }
              list = !page_no ? dataList : list.concat(dataList);
              setExpertList(list);
              page = dataList[dataList.length - 1].create_time || dataList[dataList.length - 1].r_time || '';
            } else {
              setHasMore(false);
              if (!page_no) {
                list = '没有相关内容';
                setExpertList(list);
              }
              page = Array.isArray(list) && list.length ? (list[list.length - 1].create_time || dataList[dataList.length - 1].r_time || '') : '';
            }
          }
        }
      }).catch((error) => {
        loading = false;
      });
    }
  };

  const getLeague = (page_no) => {
    if (!!query.id) {
      if (loading) return;
      loading = true;
      axios.get('/api/v1/league', {
        timeout: 5000,
        params: {
          status: 1,
          uid: query.id,
          last_time: page_no || '',
          rn: 10
        }
      }).then((response) => {
        loading = false;
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 200 && Array.isArray(response.data.data)) {
            const dataList = response.data.data;
            if (dataList.length > 0) {
              if (dataList.length < 10) {
                setHasMore(false);
              } else {
                if (!page_no) {
                  setHasMore(true);
                }
              }
              list = !page_no ? dataList : list.concat(dataList);
              setExpertList(list);
              page = dataList[dataList.length - 1].create_time || '';
            } else {
              setHasMore(false);
              if (!page_no) {
                list = '没有相关内容';
                setExpertList(list);
              }
              page = Array.isArray(list) && list.length ? (list[list.length - 1].create_time || '') : '';
            }
          }
        }
      }).catch((error) => {
        loading = false;
      });
    }
  };

  const getVideo = () => {
    if (!!query.id) {
      axios.get(`/api2/user/video/${query.id}/0`, {
        timeout: 5000,
      }).then((response) => {
        if (!!response && response.status === 200 && response.data) {
          if (response.data.code === 0 && Array.isArray(response.data.data)) {
            const dataList = response.data.data;
            setExpertList(dataList);
          }
        }
      }).catch((error) => {
        console.log(error)
      });
    }
  };

  const toggleNav = (key) => {
    if (key !== navActive) {
      setHasMore(false);
      setNavActive(key);
      setExpertList([]);
      page = '';
      list = [];
      audio.current = {};
      setCurrentAudioId(0);
      audioProgress.current = {};
      if (type === 'reporter') {
        if (key === 1) {
          getQuestionList();
        } else if (key === 2) {
          getArticle();
        } else if (key === 3) {
          getLeague();
        } else if (key === 6) {
          getVideo();
        }
      } else if (type === 'proficient') {
        if (key === 4) {
          getAnswer(0, 0);
        } else if (key === 5) {
          getAnswer(0, 1);
        } else if (key === 6) {
          getVideo();
        }
      } else if (type === 'lanjing') {
        getArticle();
      }
    }
  };

  const setApply = (type) => {
    setApplyType(type);
  };

  const setChangeShowLogin = (value, type) => {
    setIsShowLogin(value);
    if (type === 'close') {
      setApply('');
    }
  };

  const audioSetExpertList = (newList) => {
    list = newList;
    setExpertList(list);
  };

  const drawErrorModal = (msg) => {
    if (msg) {
      setErrorText(msg);
      clearTimeout(errorTimer);
      errorTimer = setTimeout(() => {
        setErrorText('');
        setApply('');
      }, 2000)
    }
  };

  return (
    <>
      <section className="person-top-background-box">
        <div className="o-h bg-c-192035ffffff person-top-background">
          <div className="w-100p bg-c-192035ffffff person-top-box">
            <div className="p-r person-avatar-content-box">
              <div className="p-a bg-c-192035ffffff person-avatar-box">
                <div className="w-100p h-100p o-h default-avatar person-avatar-background">
                  {!!detail.head_img && <img alt="" className="w-100p h-100p o-f-c" src={detail.head_img} />}
                </div>
              </div>
              {
                (!!detail.tid || !!detail.from_user_id || !!detail.uid) &&
                <div className="person-name-box">
                  <div className="w-100p d-f f-b-c person-name">
                    <div className="d-f f-s-c person-name-text">
                      <div className={`l-c-1 t-o-e o-h f-s-20 l-h-12 f-w-b c-ffffff191c27 person-name-detail`}>{detail.real_name || ''}</div>
                      {
                        !!type && <img className="person-name-icon-box" src={
                          type === 'reporter' ? 'https://file.jingpt.com/wap/images/reporter-237.png' :
                            type === 'proficient' ? 'https://file.jingpt.com/wap/images/expert-237.png' :
                              'https://file.jingpt.com/wap/images/lanjing-830.png'
                        } alt=""/>
                      }
                    </div>
                    {
                      type && type === 'lanjing' ?
                        <OpenAppChannel className="f-s-0 f-s-14 l-h-1 c-fff bg-c-d95757339aff-84bfff person-button-follow" openUrl={props.openUrl || 'lanjing://'}>
                          加关注
                        </OpenAppChannel>
                        :
                        <OpenAppChannel className="f-s-0 f-s-12 l-h-15 c-fff bg-c-d95757339aff-84bfff person-button" openUrl={props.openUrl || 'lanjing://'}>
                          加好友
                        </OpenAppChannel>
                    }
                  </div>
                  <div className={`o-h t-o-e l-c-2 f-s-13 c-7d7e809395a2`}>
                    {detail.company_name || ''} {detail.title || detail.position || ''}
                    {
                      !!detail.city &&
                      <>
                        <svg className="city-info-icon" width="8" height="11" viewBox="0 0 10 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
                          <path className="f-cca166" d="M6.08035673,12.2177325 C5.99724124,12.332646 5.89632424,12.433563 5.78141075,12.5166785 C5.18475056,12.9482354 4.35121587,12.8143928 3.91965891,12.2177326 L3.91964873,12.21774 C1.5287718,8.91217153 0.333333333,6.5062582 0.333333333,5 C0.333333333,2.42267117 2.42267117,0.333333333 5,0.333333333 C7.57732883,0.333333333 9.66666667,2.42267117 9.66666667,5 C9.66666667,6.50625705 8.47123002,8.91216787 6.08035673,12.2177325 Z M5,7 C6.1045695,7 7,6.1045695 7,5 C7,3.8954305 6.1045695,3 5,3 C3.8954305,3 3,3.8954305 3,5 C3,6.1045695 3.8954305,7 5,7 Z" />
                        </svg>
                        {detail.city}
                      </>
                    }
                  </div>
                </div>
              }
            </div>

            {
              ((typeof detail.interview_number === 'number' && detail.interview_number !== 0) || (typeof detail.follow_number === 'number' && detail.follow_number !== 0)) &&
              <div className="d-f f-s-c person-top-number-box">
                {
                  typeof detail.interview_number === 'number' && detail.interview_number !== 0 &&
                  <div className="t-a-c person-top-number">
                    <div className="f-s-24 f-w-b l-h-12 c-1561f5">{detail.interview_number}</div>
                    <div className="f-s-13 l-h-138462 c-9ea5bb">采访次数</div>
                  </div>
                }
                {
                  typeof detail.follow_number === 'number' && detail.follow_number !== 0 &&
                  <div className="t-a-c">
                    <div className="f-s-24 f-w-b l-h-12 c-1561f5">{detail.follow_number > 999 ? '999+' : detail.follow_number}</div>
                    <div className="f-s-13 l-h-138462 c-9ea5bb">被关注</div>
                  </div>
                }
              </div>
            }

            <div className="d-f f-s-c l-h-1 person-top-rank-box">
              <span className="f-s-12 c-9ea5bb person-top-rank">{type === 'reporter' ? '从业年限' : '荣誉'}</span>
              <span className="f-s-14 f-w-n-b c-f4d49cdcab6e">
                {
                  type === 'reporter' ? (`${typeof detail.career_duration === 'number' && detail.career_duration !== 0 ? `${detail.career_duration}年` : '待完善'}`) : type === 'proficient' ? '鲸平台认证专家' : '认证蓝鲸号'
                }
              </span>
            </div>

            <div className="person-top-description-box">
              <div className="f-w-n-b f-s-16 l-h-163636 c-ffffff333333 person-top-description-tip">自述/介绍</div>
              <div className={`person-top-description ${arrowShown ? 'person-top-description-arrow' : ''}`} onClick={() => setDescription(!description)}>
                <div ref={contentRef} className={`f-s-15 l-h-146667 c-c8c9da646566 ${!description ? 'o-h t-o-e l-c-2 person-top-description-content' : ''}`}>{detail.desc || ''}</div>
                {
                  arrowShown &&
                  <div className="o-h f-s-12 c-c8c9da565f71 t-a-c person-top-description-icon-box">
                    <svg className={`${!description ? 'person-top-description-icon' : 'person-top-description-icon-toggle'}`} width="13" height="13" viewBox="0 0 5 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
                      <path className="f-5b5c5f6e6f6f" d="M0,5 C0,4.82077077 0.060041712,4.64154153 0.17977264,4.50490938 L3.95147314,0.205149157 C4.19140499,-0.0683830523 4.58032488,-0.0683830523 4.82013924,0.205149157 C5.05995359,0.478547413 5.05995359,0.921932139 4.82013924,1.19546435 L1.48283054,5 L4.82002174,8.80453565 C5.05983609,9.07793391 5.05983609,9.52145259 4.82002174,9.79485084 C4.58020738,10.0683831 4.19128749,10.0683831 3.95135564,9.79485084 L0.179655142,5.49509062 C0.0599242135,5.35845847 0,5.17922923 0,5 Z" />
                    </svg>
                  </div>
                }
              </div>
              <div className="f-w-n-b f-s-16 l-h-163636 c-ffffff333333 person-top-description-tip">关注领域</div>
              <div className="f-s-15 l-h-146667 t-a-c clearfix">
                {Array.isArray(detail.focus_areas) && detail.focus_areas.map(focusItem => <div key={focusItem.id} className="f-l t-o-e l-c-1 o-h c-c8c9da565f71 bg-c-203051f5f6fa person-top-tag">{focusItem.industry}</div>)}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-c-171b1ft">
          <div className="d-f f-s-c f-s-15 l-h-15 c-afb0b3646566 t-a-c b-c-1e252bt person-nav-box">
            {navList.map(item => <div key={item.key} className={`p-r person-nav ${navActive === item.key ? 'f-s-18 f-w-b c-1a8cff person-nav-active' : ''}`} onClick={() => toggleNav(item.key)}>{item.name}</div>)}
          </div>
        </div>
      </section>
      <section>
        <div>
          {
            navActive === 1 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                Array.isArray(expertList) && !!expertList.length && expertList.map((item) => {
                  return (
                    <div key={item.id} className="b-c-11141cf5f6fa person-question-box">
                      <Link to={{
                        pathname: 'qa_question.html',
                        search: `?id=${item.id}`,
                      }}>
                        <div className="l-c-2 t-o-e o-h f-s-18 f-w-b l-h-144444 c-ffffff191c27 person-question">{item.title}</div>
                      </Link>
                      <div className="d-f f-s-c">
                        <div className="f-s-0 d-f f-c-c p-r f-s-12 l-h-1 c-fff person-question-icon">
                          <svg width="16" height="14" viewBox="0 0 16 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                              <linearGradient x1="2.26147953%" y1="50%" x2="93.4499392%" y2="50%" id="linearGradient-1">
                                <stop stopColor="#FF75B0" offset="0%" />
                                <stop stopColor="#FD4444" offset="100%" />
                              </linearGradient>
                            </defs>
                            <path className="f-d95757ff75b0-fd4444" d="M4.02575755,0.6 C2.52966938,0.6 1.31685029,1.79001552 1.31685029,3.25797406 L1.31685029,10.5674027 L0.842299017,12.1194984 C0.681344253,12.6459266 0.977619046,13.2031607 1.50404729,13.3641154 C1.69060417,13.421155 1.88979826,13.4221956 2.07694092,13.3671084 L3.68714414,12.89313 L12.4910927,12.89313 C13.9871809,12.89313 15.2,11.7031145 15.2,10.235156 L15.2,3.25797406 C15.2,1.79001552 13.9871809,0.6 12.4910927,0.6 L4.02575755,0.6 Z" />
                          </svg>
                        </div>
                        <div className="f-g-1 d-f f-b-c c-6465669395a2">
                          <div><span className="c-afb0b3646566">公开问题</span> | {dateDiff(item.create_time * 1000)} </div>
                          {typeof item.participate_number === 'number' && item.participate_number > 0 && <div>共{item.participate_number}人参与</div>}
                        </div>
                      </div>
                    </div>
                  )
                })
            )
          }
          {
            navActive === 2 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                Array.isArray(expertList) && !!expertList.length && <List list={expertList} type="person" />
            )
          }

          {
            navActive === 4 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                Array.isArray(expertList) && !!expertList.length && expertList.map((item) => {
                  return (
                    <div key={item.id} className="b-c-11141cf5f6fa person-question-box">
                      <Link to={{
                        pathname: 'qa_answer.html',
                        search: `?id=${item.id}`,
                      }}>
                        <div className="l-c-2 t-o-e o-h f-s-18 f-w-b l-h-144444 c-ffffff191c27 person-question">
                          {item.title}
                        </div>
                      </Link>
                      <div className="f-s-15 l-h-146667 bg-c-0f1214-171b1fffffff person-answer-box">
                        {
                          item.content_type === 1 ?
                            <AudioPlayer
                              item={item}
                              expertList={expertList}
                              setExpertList={audioSetExpertList}
                              currentAudioId={currentAudioId}
                              setCurrentAudioId={setCurrentAudioId}
                              audio={audio}
                              audioProgress={audioProgress}
                            /> :
                            item.content &&
                            <Link to={{
                              pathname: 'qa_answer.html',
                              search: `?id=${item.id}`,
                            }}>
                              <div className="c-c8c9da565f71 o-h t-o-e l-c-3 editor-text person-answer-content" dangerouslySetInnerHTML={{ __html: typeof item.content === 'string' ? xss(item.content) : null }}></div>
                            </Link>
                        }
                        <div className="f-s-13 c-565f719ea5bb">{typeof item.create_time === 'number' && `编辑于${dateDiff(item.create_time * 1000)}`}<span className="person-view-num">{typeof item.view_num === 'number' && item.view_num > 0 && `${item.view_num}人查看`}</span></div>
                      </div>
                    </div>
                  )
                })
            )
          }

          {
            navActive === 5 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                expertList.map(item => {
                  return (
                    <div key={item.id} className="b-c-11141cf5f6fa person-question-box">
                      <Link to={{
                        pathname: 'qa_viewpoint.html',
                        search: `?id=${item.id}`,
                      }}>
                        <div className="l-c-2 t-o-e o-h f-s-18 f-w-b l-h-144444 c-ffffff191c27 person-question">
                          {item.title}
                        </div>
                      </Link>
                      <div>
                        {
                          item.content_type === 1 ?
                            <AudioPlayer
                              item={item}
                              expertList={expertList}
                              setExpertList={audioSetExpertList}
                              currentAudioId={currentAudioId}
                              setCurrentAudioId={setCurrentAudioId}
                              audio={audio}
                              audioProgress={audioProgress}
                            /> :
                            item.content &&
                            <Link to={{
                              pathname: 'qa_viewpoint.html',
                              search: `?id=${item.id}`,
                            }}>
                              <div className="f-s-15 l-h-146667 c-c8c9da565f71 o-h t-o-e l-c-3 editor-text person-viewpoint-content" dangerouslySetInnerHTML={{ __html: typeof item.content === 'string' ? xss(item.content) : null }}></div>
                            </Link>
                        }
                        <div className="f-s-13 c-565f719ea5bb">{typeof item.create_time === 'number' && `编辑于${dateDiff(item.create_time * 1000)}`}<span className="person-view-num">{typeof item.view_num === 'number' && item.view_num > 0 && `${item.view_num}人查看`}</span></div>
                      </div>
                    </div>
                  )
                })
            )
          }

          {
            navActive === 6 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                Array.isArray(expertList) && !!expertList.length && expertList.map((item) => <PersonVideoList key={item.id} item={item} type="list" />)
            )
          }

          {
            navActive === 7 && (
              typeof expertList === 'string' && !!expertList ?
                <div className="f-s-14 l-h-142858 c-6465669ea5bb t-a-c">
                  <div className="person-list-empty-image person-list-empty-image-data" />
                  暂无内容
                </div> :
                Array.isArray(expertList) && !!expertList.length && expertList.map(item => {
                  return (
                    <div key={item.tid} className="b-c-11141cf5f6fa person-question-box">
                      <Link to={{
                        pathname: 'deepnews.html',
                        search: `?id=${item.tid}&os=${query.os || 'web'}&sv=${query.sv || '8.3.0'}`,
                      }}>
                        <div className="l-c-2 t-o-e o-h f-s-18 f-w-b l-h-144444 c-ffffff191c27 person-question">
                          {item.title}
                        </div>
                        <div className="f-s-15 l-h-146667 c-c8c9da565f71 o-h t-o-e l-c-3 editor-text person-viewpoint-content">
                          {item.abstract_info}
                        </div>
                        <div className="d-f f-b-c f-s-13 c-565f719ea5bb">
                          <div className="o-h t-o-el w-s-n">{typeof item.r_time === 'number' && `编辑于${dateDiff(item.r_time * 1000)}`}</div>
                          {
                            typeof item.view_num === 'number' && item.view_num > 0 &&
                            <div className="f-s-0 d-f f-s-c person-view-num">
                              <svg className="m-r-5" width="18px" height="14px" viewBox="0 0 18 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                <g fill="#9EA5BB" fillRule="nonzero">
                                  <path d="M17.5,6.25188311 C17.5,6.14952494 17.4822348,6.06390563 17.4771867,6.05371585 C17.473363,6.00299709 17.4555978,5.91055669 17.4390786,5.8620349 C17.4346534,5.84996199 17.4289179,5.83730322 17.4238697,5.82523031 C17.4149549,5.79740195 17.4054601,5.77020129 17.3946764,5.7485663 C15.7809681,2.31065411 12.3066652,0 8.75045348,0 C5.1948862,0 1.72088399,2.30851991 0.11450086,5.72783104 C0.0951460677,5.76494947 0.0814838577,5.80049863 0.0729127612,5.8314237 C0.069110548,5.84161348 0.0646638741,5.85119648 0.0611838912,5.86017271 C0.0294342932,5.95077183 0.0288113495,6.01381457 0.0313461583,5.99743142 C0.0164380188,6.06390565 0.00277582974,6.19622639 0.00277582974,6.19622639 C-0.00102638346,6.23608581 -0.00102638346,6.2679315 0.00342026946,6.30751894 C0.00342026946,6.30751894 0.0170609835,6.42314266 0.0237417319,6.44661893 C0.025632101,6.47938527 0.0338809881,6.52700733 0.0437194889,6.57029823 L0.0430750492,6.57029823 C0.0516461457,6.60739575 0.0633965117,6.64325878 0.0795720345,6.67849408 C0.0878423967,6.70569474 0.0976808975,6.73105412 0.106251994,6.75022013 C1.7221514,10.1887182 5.19553064,12.5 8.75045348,12.5 C12.3073097,12.5 15.7816126,10.1906013 17.3769113,6.78855214 C17.4016364,6.74402674 17.4175327,6.70199126 17.4283164,6.66550054 C17.433386,6.6543901 17.4378542,6.64449327 17.4410119,6.63459641 C17.4689593,6.55542156 17.4746519,6.48681313 17.4721171,6.48681313 L17.4715156,6.48741992 C17.4829008,6.43243271 17.5,6.35020303 17.5,6.25188311 Z M16.6420735,6.2955825 C16.6414241,6.29817786 16.6400806,6.3013839 16.6387596,6.30397928 C16.6367891,6.31169994 16.6334976,6.32072921 16.6314824,6.32975847 C15.1347131,9.47174478 11.9744713,11.579968 8.75001119,11.579968 C5.53350003,11.579968 2.37885602,9.4775898 0.86719652,6.32461136 C0.863546735,6.31366283 0.860904564,6.30332499 0.856941307,6.29303077 C0.856269572,6.28271473 0.854299135,6.27433977 0.853649785,6.26851655 C0.852328699,6.26210447 0.851007614,6.2530752 0.85,6.24531091 L0.85,6.23726309 C0.853649785,6.22404634 0.856269572,6.21085141 0.857613042,6.1963479 C0.860255213,6.18862724 0.862248034,6.18121188 0.865226084,6.17283693 C2.36262232,3.02921487 5.52552872,0.920031997 8.74998881,0.920031997 C11.9757476,0.920031997 15.138027,3.03113413 16.6308106,6.16991439 C16.6321317,6.17604295 16.6334752,6.18121188 16.635468,6.18539935 C16.6367891,6.19054646 16.6380878,6.19571539 16.64073,6.20118966 C16.6440439,6.22472243 16.6466861,6.24792807 16.65,6.25950909 C16.6460367,6.27174439 16.6440663,6.28334721 16.6420735,6.2955825 Z"></path>
                                  <path d="M8.75043198,3.40912135 C7.14245924,3.40912135 5.83346535,4.68349313 5.83346535,6.25002092 C5.83346535,7.81623485 7.14245924,9.09123435 8.75043198,9.09123435 C10.3584047,9.09123435 11.6673986,7.81623485 11.6673986,6.25002092 C11.6673986,4.68349313 10.3584047,3.40912135 8.75043198,3.40912135 Z M8.7504062,8.29542775 C7.59338802,8.29542775 6.65043198,7.37768821 6.65043198,6.24998955 C6.65043198,5.12264236 7.59338802,4.20492795 8.7504062,4.20492795 C9.90817187,4.20492795 10.850432,5.12266748 10.850432,6.24998955 C10.850432,7.37768821 9.90817187,8.29542775 8.7504062,8.29542775 Z"></path>
                                </g>
                              </svg>
                              {item.view_num}
                            </div>
                          }
                        </div>
                      </Link>
                    </div>
                  )
                })
            )
          }
        </div>
        <div ref={loadingDivRef} className="m-t-10 t-a-c">{(Array.isArray(expertList) && expertList.length > 0) ? hasMore ? '加载中...' : '到底了' : ''}</div>
      </section>
      <section className="w-100p m-w-480 bg-c-0f1214ffffff person-bottom-box">
        <div className="f-s-17 f-w-b l-h-141667 c-fff t-a-c bg-c-d95757339aff-84bfff person-bottom-button" onClick={() => setIsShowApply(true)}>
          我要申请入驻
        </div>
      </section>
      {
        isShowApply &&
        <section className="w-100p h-100p f-s-14 l-h-142858 c-191c27 person-apply-box">
          <div className="w-100p h-100p bg-c-000-50 person-apply-mask" onClick={() => {
            setApply('');
            setIsShowApply(false)
          }} />
          <div className="p-r bg-c-fff person-apply-content-box">
            <div className="p-a person-apply-close" onClick={() => {
              setApply('');
              setIsShowApply(false)
            }}>
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.203033447">
                  <rect x="0" y="0" width="24" height="24"></rect>
                  <path d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M9.17157288,7.75735931 C8.78104858,7.36683502 8.1478836,7.36683502 7.75735931,7.75735931 C7.36683502,8.1478836 7.36683502,8.78104858 7.75735931,9.17157288 L7.75735931,9.17157288 L10.5844661,11.9994661 L7.75735931,14.8284271 C7.36683502,15.2189514 7.36683502,15.8521164 7.75735931,16.2426407 C8.1478836,16.633165 8.78104858,16.633165 9.17157288,16.2426407 L9.17157288,16.2426407 L11.9994661,13.4144661 L14.8284271,16.2426407 C15.2189514,16.633165 15.8521164,16.633165 16.2426407,16.2426407 C16.633165,15.8521164 16.633165,15.2189514 16.2426407,14.8284271 L16.2426407,14.8284271 L13.4144661,11.9994661 L16.2426407,9.17157288 C16.633165,8.78104858 16.633165,8.1478836 16.2426407,7.75735931 C15.8521164,7.36683502 15.2189514,7.36683502 14.8284271,7.75735931 L14.8284271,7.75735931 L11.9994661,10.5844661 Z" fill="#2C3840"></path>
                </g>
              </svg>
            </div>
            <div className="m-b-20 t-a-c f-s-16 l-h-1375 f-w-n-b person-apply-title">请选择你的认证身份</div>
            <div className="d-f f-d-c f-b-c person-apply-button-list">
              <div className="d-f f-d-c f-b-c person-apply-button-box" onClick={() => setApply(2)}>
                <div className="person-apply-button person-apply-button-reporter" />
                <div>我是记者</div>
              </div>
              <div className="d-f f-d-c f-b-c person-apply-button-box" onClick={() => setApply(3)}>
                <div className="person-apply-button person-apply-button-proficient" />
                <div>我是专家</div>
              </div>
              {/* <div className="d-f f-d-c f-b-c person-apply-button-box" onClick={() => setApply(5)}>
                <div className="person-apply-button person-apply-button-lanjing" />
                <div>我是蓝鲸号</div>
              </div> */}
            </div>
          </div>
        </section>
      }

      {isShowLogin && <Login type="code" isShow={isShowLogin} setIsShow={setChangeShowLogin} />}

      {
        errorText &&
        <section className="w-100p h-100p global-message-wrap">
          <div className="f-s-16 bg-c-000 c-afb0b3 t-a-c global-message-box">{errorText}</div>
        </section>
      }
    </>
  )
};

export default observer(Person);